module.exports = __webpack_public_path__ + "img/gnome-main-logo.eafec7d4.png";